import * as PIXI from "pixi.js";

import spritesh from "./images/logo/spritesheet.png";
import spritejson from "./images/logo/spritesheet.json";

export default function loading() {

    
}
